import { getKeys } from './getKeys'

export const riskAssessmentReportTranslations = {
  RISK_ASSESSMENT_SCORES: 'Risk Assessment Scores',
  TAB_BY_ASSESSMENT: 'By Risk Assessment',
  TAB_BY_RESIDENT: 'By Resident',
  RISK_ASSESSMENT: 'Risk Assessment',
  RISK_ASSESSMENT_FILTER: 'Select Risk Assessment',
  FILTERS: 'Filters',
  TOOLTIP_ASSESSMENT_COMPLETE: 'No Score',
  TOOLTIP_REVIEWED_BY: 'By {{name}}',
  TOOLTIP_REVIEWED_ON: 'Reviewed on {{date}}',
  RA_SHORT: 'RA',
  RISK: 'Risk',
  VIEW_TEXT: 'View all {{residents}}',

  // empty states
  EMPTY_STATE_RISK_ASSESSMENT_TITLE: 'Select Risk Assessment to start!',
  EMPTY_STATE_ASSESSMENT_DESCRIPTION:
    'Use filters to select the Risk Assessment to explore.',
  EMPTY_STATE_RESIDENT_TITLE:
    'Select Risk Assessment to start!-add dynamic resi',
  EMPTY_STATE_RESIDENT_DESCRIPTION:
    'Select Risk Assessment to start!-add dynamic resi',
  EMPTY_STATE_NO_DATA: 'No data to show',
  EMPTY_STATE_NO_DATA_DESCRIPTION:
    'There is no data to display. Try updating your filters or create Risk Assessments to start tracking scores.',

  // early access
  EARLY_ACCESS_TITLE: 'Early Access',
  EARLY_ACCESS_DESCRIPTION: 'Discover our new report and share your feedback',
  EARLY_ACCESS_BUTTON: 'Share your feedback',
  CARE_PLANNING: '{{carePlanText}}ning'
}

export const riskAssessmentReportConstants = getKeys(
  riskAssessmentReportTranslations
)
